export let routes = [
  {
    path: '/x3-side-classroom',
    name: 'x3-side-classroom',
    component: () => import('@x3/js/side/classroom/classroom.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-classroom-checking',
    name: 'x3-side-classroom-checking',
    component: () => import('@x3/js/side/classroom/classroom-checking.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsClassroom(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-classroom',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsClassroomChecking(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-classroom-checking',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
